if (!window.__missenceComparison) {
  window.__missenceComparison = true;

  const initComparison = (root) => {
    if (!root || root.dataset.missenceComparisonReady === 'true') return;
    root.dataset.missenceComparisonReady = 'true';
    root.classList.add('is-enhanced');

    const tabs = Array.from(root.querySelectorAll('[role="tab"][data-missence-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-missence-comparison-panel]'));

    const selectTab = (selectedTab, moveFocus) => {
      tabs.forEach((tab) => {
        const isSelected = tab === selectedTab;
        tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        tab.tabIndex = isSelected ? 0 : -1;
        tab.classList.toggle('is-active', isSelected);
      });

      const panelId = selectedTab.getAttribute('aria-controls');
      panels.forEach((panel) => {
        panel.hidden = panel.id !== panelId;
      });

      if (moveFocus) selectedTab.focus();
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => selectTab(tab, false));

      tab.addEventListener('keydown', (event) => {
        let nextTab = null;

        if (event.key === 'ArrowRight') nextTab = tabs[(index + 1) % tabs.length];
        if (event.key === 'ArrowLeft') nextTab = tabs[(index - 1 + tabs.length) % tabs.length];
        if (event.key === 'Home') nextTab = tabs[0];
        if (event.key === 'End') nextTab = tabs[tabs.length - 1];

        if (!nextTab) return;
        event.preventDefault();
        selectTab(nextTab, true);
      });
    });

    root.querySelectorAll('[data-missence-comparison-toggle]').forEach((button) => {
      const table = document.getElementById(button.getAttribute('aria-controls'));
      if (!table) return;

      button.hidden = false;

      button.addEventListener('click', () => {
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        const willExpand = !isExpanded;

        table.classList.toggle('is-expanded', willExpand);
        button.setAttribute('aria-expanded', willExpand ? 'true' : 'false');
        button.textContent = willExpand ? button.dataset.labelCollapse : button.dataset.labelExpand;

        if (willExpand) {
          // Primera fila nueva visible: la de la tabla o, con la lista móvil, su primera categoría nueva.
          const firstExtraHeader = Array.from(
            (button.closest('[data-missence-comparison-panel]') || table).querySelectorAll(
              '[data-missence-comparison-first-extra] th, [data-missence-comparison-first-extra][data-missence-comparison-focus]'
            )
          ).find((element) => element.getClientRects().length > 0);
          if (firstExtraHeader) {
            firstExtraHeader.tabIndex = -1;
            firstExtraHeader.focus();
          }
          return;
        }

        button.focus();
        button.scrollIntoView({ block: 'nearest' });
      });
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-missence-comparison]').forEach(initComparison);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
}
